import {
    GET_REFERRALS_COUNT_PENDING,
    GET_REFERRALS_COUNT_FULFILLED,
    GET_REFERRALS_COUNT_REJECTED,
    GET_REFERRALS_LIST_PENDING,
    GET_REFERRALS_LIST_FULFILLED,
    GET_REFERRALS_LIST_REJECTED,
    GET_REFERRAL_PENDING,
    GET_REFERRAL_FULFILLED,
    GET_REFERRAL_REJECTED,
    DELETE_REFERRAL_FULFILLED,
    DELETE_REFERRAL_PENDING,
    CREATE_NEW_REFERRAL,
    ADD_REFERRAL_PENDING,
    UPDATE_REFERRAL_SAVE_PENDING,
    UPDATE_REFERRAL_SAVE_AND_CLOSE_PENDING,
    TRANSFER_REFERRAL_PENDING,
    ARCHIVE_REFERRAL_PENDING,

    ADD_REFERRAL_FULFILLED,
    UPDATE_REFERRAL_SAVE_FULFILLED,
    UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED,
    TRANSFER_REFERRAL_FULFILLED,
    ARCHIVE_REFERRAL_FULFILLED,
} from '../../actions/action-constants';

const initialState = {
    referralEntry: [],
    referrals: [],
    alchoholaftercareprograms: [],
    bop: [],
    drugaftercareprograms: [],
    financialresponsibilityprograms: [],
    gangaffiliations: [],
    institutions: [],
    bopinstitutions: [],
    levelsofsecurity: [],
    referralsources: [],
    count: -1,
    boprrccount: -1,
    opcusptspsycount: -1,
    loadingList: false,
    addSuccess: false,
    updateSuccessSave: false,
    updateSuccessSaveAndClose: false,
    deleteSuccess: false,
    transferSuccess: false,
    archiveSuccess: false,

    dataEntry: {},
    dataList: [],

    errorInvalidEntry: false,
    errors: [],
};

const reducerReferrals = (state = initialState, action) => {
  var dataEntry;
  var dataList;
  switch (action.type) {
                                                                                                /* this was added with the redux promise middleware 
                                                                                                you now have to put _FULFILLED, _REJECTED, after the action name to get the response
                                                                                                without this middleware you will not get these status'
                                                                                                */

    
    case GET_REFERRAL_PENDING:
    case ADD_REFERRAL_PENDING:
    case UPDATE_REFERRAL_SAVE_PENDING:
    case UPDATE_REFERRAL_SAVE_AND_CLOSE_PENDING:
    case TRANSFER_REFERRAL_PENDING:
    case ARCHIVE_REFERRAL_PENDING:
    case DELETE_REFERRAL_PENDING:
    case GET_REFERRALS_LIST_PENDING:
    case GET_REFERRALS_COUNT_PENDING:
        state = {
            ...state
            , loadingList: true
        };
        break;
    case CREATE_NEW_REFERRAL:
        state = {
            ...state
            , dataEntry: action.payload
        };
        break;
    case GET_REFERRALS_COUNT_FULFILLED:
        var tblcount = -1;
        var boprrccount = -1;
        var opcusptspsycount = -1;
        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.referralscount[0] : [] ;
        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {
                        tblcount = dataEntry.count;
                        boprrccount = dataEntry.boprrccount;
                        opcusptspsycount = dataEntry.opcusptspsycount;
        }
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,            
            updateSuccessSave: false,
            updateSuccessSaveAndClose: false,
            deleteSuccess: false,
            transferSuccess: false,
            archiveSuccess: false,
            errorInvalidEntry: false,
            count: tblcount,
            boprrccount: boprrccount,
            opcusptspsycount: opcusptspsycount,
        };
        break;
    case GET_REFERRALS_LIST_FULFILLED:
                                                                                    // console.log('4444-20082 - reducerReferrals : GET_REFERRALS_LIST_FULFILLED = ', action.payload);
                                                                                                // if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {
                                                                                                //     dataList = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.referrals : [] ;
                                                                                                // } else {
                                                                                                //     dataList = [] ;
                                                                                                // }
        dataList = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.referrals : [] ;
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,
            updateSuccessSave: false,
            updateSuccessSaveAndClose: false,
            deleteSuccess: false,
            transferSuccess: false,
            archiveSuccess: false,
            errorInvalidEntry: false,
            referralEntry: [],
            dataList: dataList,
                                                                                                // referrals: [...state.referrals, ...action.payload.data.referrals],
        };
        break;
    case GET_REFERRAL_FULFILLED:
    // console.log("44-55-44 data ");
    // console.log(action.payload.data);
        var invalidEntry = false;
        if(action.payload.data.referrals.length > 0) {
            dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.referrals[0] : [] ;


            if (dataEntry.program === '' || dataEntry.program === null ) {
                dataEntry.program = '1';
            } else {
                dataEntry.program = dataEntry.program.toString();;
            }
            
            if (dataEntry.referraloutcome === '' || dataEntry.referraloutcome === null ) {
                dataEntry.referraloutcome = '1';
            } else {
                dataEntry.referraloutcome = dataEntry.referraloutcome.toString();;
            }


        } else {
            dataEntry = {};
            invalidEntry = true;
        }
        state = {
            ...state,
            loadingList: false,
            errorInvalidEntry: invalidEntry,
            dataEntry: dataEntry,
            referrals: [],
                                                                                                        // , referrals: [...state.referrals, ...action.payload.data.referrals]
        };
        break;
    case DELETE_REFERRAL_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , deleteSuccess: true
        };
        break;
    case ADD_REFERRAL_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , addSuccess: true
        };
        break;
    case UPDATE_REFERRAL_SAVE_FULFILLED:
        state = {
            ...state,
            loadingList: false,
            updateSuccessSave: true,
            updateSuccessSaveAndClose: false,
        };
        break;
    case UPDATE_REFERRAL_SAVE_AND_CLOSE_FULFILLED:
        state = {
            ...state,
            loadingList: false,
            updateSuccessSave: false,
            updateSuccessSaveAndClose: true,
        };
        break;
    case TRANSFER_REFERRAL_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , transferSuccess: true
        };
        break;        
    case ARCHIVE_REFERRAL_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , archiveSuccess: true
        };
        break;        
    case GET_REFERRALS_COUNT_REJECTED:
    case GET_REFERRALS_LIST_REJECTED:
    case GET_REFERRAL_REJECTED:
        state = {
            ...state
            , errors: [action.payload.response]
        };
        break;

    default:
        return state;
  }

  return state;
};
export default reducerReferrals;
